import React, { memo } from 'react'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Box } from 'transfix-ui/core'
import { TCarrierStatus } from 'types'
import { getNewCarrierStatus } from 'utils/carriers/getNewCarrierStatus'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { carrierStatuses, CARRIER_STATUSES, CARRIER_STATUS_ICON_MAP } from 'constants/carriers'

interface ICarrierStatus {
  status?: TCarrierStatus
  displayStatus?: boolean
  warnOnly?: boolean
  showTooltip?: boolean
}

const CarrierStatus = memo<ICarrierStatus>(
  ({ displayStatus = false, showTooltip = false, status, warnOnly = false }) => {
    const isUseNewStateTagsMpEnabled = useFeatureFlag('useNewStateTagsMp')

    if (!status || (warnOnly && carrierStatuses[status] === carrierStatuses.activated)) return <></>
    const state = CARRIER_STATUSES.find(carrierStatus => carrierStatus.key === status)
    const stateName = getNewCarrierStatus(state?.name || '', isUseNewStateTagsMpEnabled)
    const { Icon, color } = (state && CARRIER_STATUS_ICON_MAP[state.name]) || {}

    return (
      <span>
        {showTooltip && (
          <Tooltip
            position='top'
            trigger={
              <div className='dib'>
                {Icon && <Icon className={`icon inline large icon-${color}`} />}
              </div>
            }
            type='dark'>
            <div>{stateName}</div>
          </Tooltip>
        )}
        <Box display='flex' alignItems='center' gap='6px' width='max-content'>
          {!showTooltip && Icon && <Icon className={`icon inline large icon-${color}`} />}
          <strong className={`text-${color}`}>{displayStatus && stateName}</strong>
        </Box>
      </span>
    )
  }
)
export default CarrierStatus
